<template>
  <div class="message-box" v-show="isShowMessageBox">
    <div class="mask"></div>
    <div class="message-content">
      <img :style="{width: iconWidth, height: iconHeight}" :src="iconUrl" alt="">
      <p>{{content}}</p>
    </div>
  </div>
</template>
 
<script>
export default {
  props: {
    content: {
      type: String,
      default: () => {
        return "";
      }
    },
    iconUrl: {
      type: Object,
      default: () => {
        return null;
      }
    },
    iconWidth: {
      type: String,
      default: () => {
        return "0.38125rem";
      }
    },
    iconHeight: {
      type: String,
      default: () => {
        return "0.38125rem";
      }
    }
  },
  data() {
    return {
      isShowMessageBox: false,
      resolve: "",
      reject: "",
      promise: "" // 保存promise对象
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm: function () {
      console.log(" ---- sdad ---");
      this.isShowMessageBox = false;
      if (this.isShowInput) {
        this.resolve(this.inputValue);
      } else {
        this.resolve("confirm");
      }
      this.remove();
    },
    // 取消,将promise断定为reject状态
    cancel: function () {
      this.isShowMessageBox = false;
      this.reject("cancel");
      this.remove();
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox: function () {
      this.isShowMessageBox = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
    closeBox: function () {
      this.isShowMessageBox = false;
      this.remove();
    },
    remove: function () {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function () {
      // this.$destroy();
      // document.body.removeChild(this.$el);
    }
  }
};
</script>
 
<style lang="scss" scoped>
.message-box {
  position: relative;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50000;
    background: rgba(0, 0, 0, 0.5);
  }
  .message-content {
    position: fixed;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.1875rem 0.15625rem;
    // min-height: 0.96875rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.4em;
    background: #fff;
    z-index: 50001;
    img {
      width: 0.38125rem;
      height: 0.38125rem;
      animation: rubberBand;
      animation-duration: 2s;
      animation-iteration-count: infinite;
    }
    p {
      font-size: 0.1rem;
      color: #0c121c;
      font-weight: 500;
      margin-left: 0.125rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messageBox/index.vue